export type WorkflowSaveDialogMessages = {
  // Dialog Messages
  deleteWorkflowDialogTitle: string;
  deleteWorkflowDialogContent: string;
  deleteWorkflowDialogCancel: string;
  deleteWorkflowDialogConfirm: string;

  //Error message
  errorRequiredTrigger: string;
  errorRequiredDescription: string;
  errorRequiredWorkflowId: string;
  errorType: string;
  workflowSaveError: string;

  //Sucess message
  workflowSavedSuccess: string;

  //Label message
  triggerLabel: string;
  descriptionLabel: string;
  workflowIdLabel: string;

  //Options
  orderStatus: string;
  startFlow: string;
  shopping: string;

  noWorkflowOption: string;
  noTriggergOption: string;

  //Button message
  activateWorkflowButton: string;
};

export const WORKFLOW_SAVE_DIALOG_MESSAGES: WorkflowSaveDialogMessages = {
  //Error message
  errorRequiredTrigger: "O Tipo do agente é obrigatório",
  errorRequiredDescription: "A descrição do agente é obrigatória",
  errorRequiredWorkflowId: "O agente é obrigatório",
  errorType: "Gatilho não encontrado",
  workflowSaveError: "Erro ao salvar o agente.",

  //Sucess message
  workflowSavedSuccess: "Agente salvo com sucesso.",

  //Label message
  triggerLabel: "Tipo do agente",
  descriptionLabel: "Descrição do agente",
  workflowIdLabel: "Agente",

  //Options
  orderStatus: "Status do pedido",
  startFlow: "Iniciar fluxo",
  shopping: "Shopping",
  noWorkflowOption: "Nenhum agente selecionado",
  noTriggergOption: "Nenhum gatilho selecionado",

  //Button message
  activateWorkflowButton: "Salvar",

  // Dialog Messages
  deleteWorkflowDialogTitle: "Excluir agente",
  deleteWorkflowDialogContent: "Tem certeza de que deseja excluir este agente?",
  deleteWorkflowDialogCancel: "Cancelar",
  deleteWorkflowDialogConfirm: "Confirmar",
};
